var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 174.598,
    viewBox: "0 0 198 174.598",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-447 -271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67997",
    "data-name": "Group 67997",
    transform: "translate(447 271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M-1062.793,1244h-97.624v21.3h133.454",
    transform: "translate(1224.96 -1090.699)",
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899-2",
    "data-name": "Path 899",
    d: "M-1141.835,1113.918l25.434-.36-.2.411,86.387,174.085-35.827-21.3-63.165-127.361Z",
    transform: "translate(1228.218 -1113.559)",
    fill: "#39fffc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899-3",
    "data-name": "Path 899",
    d: "M-1103.731,1113.992l.2-.411h-25.611l.178.359-86.38,174.087h25.251l73.754-148.612Z",
    transform: "translate(1215.341 -1113.556)",
    fill: "#ed1cb5"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.02655dda.svg";
export { ForwardRef as ReactComponent };